const initialState = {
  loading: false,
  bonusActivity: [],
  bonusActivityByEvent: [],
};

const bonusActivityReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "LOADING_BONUS_ACTIVITY": {
      return { ...state, loading: actions.loading };
    }

    case "GET_BONUS_ACTIVITIES_BY_EVENT": {
      return {
        ...state,
        bonusActivityByEvent: actions.data,
        loading: actions.loading,
      };
    }

    case "Update_Bonus_Activity": {
      return { ...state, groups: actions.data };
    }
    
    default:
      return state;
  }
};
export default bonusActivityReducer;
